import { FormControl, InputAdornment, TextField, TextFieldProps } from '@mui/material';
import { Error, Lock } from '@mui/icons-material';
import { Controller, useFormContext, useFormState } from 'react-hook-form';
import { getNestedFormErrors } from 'src/shared/functions/getNestedFormErrors';
import { Colors } from '../styles/colors';

type ControlledTextFieldProps = TextFieldProps & {
  // put extions or overrides here
  bgcolor?: string;
};

const ControlledTextField = (props: ControlledTextFieldProps) => {
  const { control } = useFormContext();
  const { errors } = useFormState();

  const { disabled, helperText, type, label, name, required, InputProps, bgcolor, ...rest } = props;

  let isError = false;
  const errorMessage = getNestedFormErrors(errors, name ?? '');
  if (errorMessage) {
    isError = true;
  }

  const componentId = `textfield-${name}-${Date.now().toString(36) + Math.random().toString(36).substring(2)}`;

  const setAndornment = () => {
    if (isError || disabled) {
      return (
        <InputAdornment position='end'>
          {isError && <Error sx={{ color: 'error.main' }} />}
          {disabled && <Lock sx={{ color: 'text.disabled' }} />}
        </InputAdornment>
      );
    }
    if (InputProps && InputProps.endAdornment) {
      return InputProps.endAdornment;
    }
    return null;
  };

  return (
    <Controller
      name={name ?? ''}
      control={control}
      render={({ field }) => (
        <FormControl
          required={required}
          fullWidth
          error={isError}
          sx={{
            ...(type && type === 'hidden' ? { display: 'none' } : null),
            '.MuiInputBase-root': {
              backgroundColor: disabled ? Colors.Form.DisabledInput : bgcolor ?? null,
            },
          }}
        >
          <TextField
            fullWidth
            size='small'
            variant='outlined'
            error={isError}
            id={componentId}
            {...field}
            {...props}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              'aria-required': required,
              'aria-invalid': isError,
              endAdornment: setAndornment(),
            }}
            helperText={errorMessage || helperText ? <em>{errorMessage || helperText}</em> : null}
          />
        </FormControl>
      )}
    />
  );
};
// ControlledTextField.defaultProps = {
//   helperText: null,
//   type: null,
//   label: null,
//   required: false,
//   disabled: false,
// };
export default ControlledTextField;
